
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.56 3.333c.382 0 .637.267.637.667s-.255.667-.638.667H2.077c-.382 0-.638-.267-.638-.667s.256-.667.638-.667H13.56zm-11.483 4h8.93c.383 0 .639-.266.639-.666S11.39 6 11.008 6h-8.93c-.383 0-.639.267-.639.667s.256.666.638.666zm12.12 2c0-.4-.255-.666-.638-.666H2.077c-.382 0-.638.266-.638.666s.256.667.638.667H13.56c.383 0 .638-.267.638-.667zm-3.19 2c.383 0 .639.267.639.667s-.256.667-.638.667h-8.93c-.383 0-.639-.267-.639-.667s.256-.667.638-.667h8.93z","fill":"#000"}})])
          )
        }
      }
    